import { Component, ComponentRef, EventEmitter, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DmpServiceAbstract } from 'src/app/services/dmp/dmp-service.abstract';
import { DocumentService } from 'src/app/services/document/document.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { DmpFormatEnum } from 'src/app/utils/enums/dmp-format.enum';
import { DmpHlGetInteropCodesEnum } from 'src/app/utils/enums/dmp-hl-get-interop-codes-params.enum';
import { DmpVisibilityEnum } from 'src/app/utils/enums/dmp-visibility.enum';
import { DmpHlGetDirectAuthentificationDmpStatus } from 'src/app/utils/interfaces/new/dmp-hl-get-direct-authentification-dmp-status.interface';
import { DmpInteropCode } from 'src/app/utils/interfaces/new/dmp-hl-get-interop-codes-response.interface';
import { DmpHlsendDocumentsDocument } from 'src/app/utils/interfaces/new/dmp-hl-send-documents-params.interface';
import { LoadingModalFragment } from '../loading/loading-modal.fragment';
import { DmpStatusEnum } from 'src/app/utils/enums/dmp-status.enum';
import { Subscription } from 'rxjs';
import { CpxHandleServiceAbstract, SessionTypeEnum } from 'src/app/services/cpx-handle/cpx-handle-service-abstract';
import { Identity } from 'src/app/utils/interfaces/new/lecture-ins.interface';
import { InternalIdTypes, NgSelectValue as NgSelectValueSrv, ProfessionsAllowingSepcialities, UserInfos } from 'src/app/services/dmp/dmp.service';
import { ReferentielService } from 'src/app/services/referentiel/referentiel.service';
import moment from 'moment';
import { DmpHlFindDocumentsResponse } from 'src/app/utils/interfaces/new/dmp-hl-find-documents-response.interface';
import { PatientService } from 'src/app/services/patient/patient.service';
import { ActionEnum, DomainEnum, LogFonctionnelCallerService, LogFonctionnelService, ResultEnum, TypeTargetEnum } from 'src/app/services/log-fonctionnel/log-fonctionnel.service';

interface NgSelectValue extends NgSelectValueSrv {
  disabled?: boolean;
  meta?: DmpInteropCode;
}

export interface DocumentFormData {
  eventCodes: Array<string>;
  format: DmpFormatEnum;
  formatCode: string;
  visibility: DmpVisibilityEnum;
  category: string;
  contentInBase64: string;
  description: string;
  title: string;
  status?: DmpStatusEnum;
  uniqueId?: string;
  uuid?: string;
  author?: Array<UserInfos>;
  performer?: UserInfos;
  authenticator?: Array<UserInfos>;
}

export interface ValidOperation {
  header: string;
  message: string;
}

enum DocumentFormatType {
  format = 'format',
  formatCode = 'formatCode',
}

enum CurrentTab {
  document = 'document',
  author = 'author',
  performer = 'performer',
  authenticator = 'authenticator',
}

interface TabInfos {
  id: CurrentTab;
  label: string;
}

@Component({
  selector: 'app-document-form',
  templateUrl: './document-form.component.html',
  styleUrls: [
    './document-form.component.scss',
    '../modal.fragment.scss'
  ]
})
export class DocumentFormComponent implements OnInit, OnDestroy {

  @Output() public closeEmitter = new EventEmitter<{docFormData: DocumentFormData, valideMessage: ValidOperation}>();

  public dmpStatus: DmpHlGetDirectAuthentificationDmpStatus;
  public patientInsIdentity: Identity;
  public patientId: string;
  public document: DocumentFormData;
  public formGroup: FormGroup;
  public formGroupVisibility: FormGroup;
  public formGroupArchive: FormGroup;
  public dmpParamCategory: Array<NgSelectValue> = [];
  public dmpParamFormatCode: Array<NgSelectValue> = [];
  public dmpParamFormat: Array<NgSelectValue> = [];
  public dmpParamVisibility: Array<NgSelectValue> = [];
  public isLoading = false;
  public documentFormatTypeTemplate = DocumentFormatType;
  public isAuthor: boolean = false;
  public isMt: boolean = false;
  public updateWithoutRight: boolean = false;
  public dmpStatusEnumTemplate = DmpStatusEnum;
  private _documentContent: string;
  public docFromDb: DmpHlFindDocumentsResponse;
  private _logCallSrv: LogFonctionnelCallerService;

  private _subUpdateVisibilityAlone: Subscription;
  private _subUpdateVisibilityFromForm: Subscription;

  public currentTabTpl = CurrentTab;
  public editTabs: Array<TabInfos> = [{
    id: CurrentTab.document,
    label: 'Document',
  }, {
    id: CurrentTab.author,
    label: 'Auteur',
  }, {
    id: CurrentTab.performer,
    label: 'Exécutant',
  },
  // {
  //   id: CurrentTab.authenticator,
  //   label: 'Validateur',
  // }
  ];
  public currentTab: TabInfos = this.editTabs[0];

  public internalIdTypes = InternalIdTypes;
  public dmpPracticeSettings: Array<NgSelectValueSrv> = [];
  public specialiteSettings: Array<NgSelectValueSrv> = [];
  public professionSettings: Array<NgSelectValueSrv> = [];
  public authorForm: FormGroup;
  public performerForm: FormGroup;
  public authenticatorForm: FormGroup;

  public authorFormWarn = `Si vous ne renseignez pas d'informations sur l'auteur de ce document, les données de la carte CPx seront utilisées.\nSi vous renseignez un auteur manuellement, l'intégralité des champs doivent être complétés.`;
  public performerFormWarn = `Les informations d'exécutant ne sont pas obligatoire,\nnéanmoins si vous souhaitez les renseigner, l'intégralité des champs doivent être complétés.`;
  public authenticatorFormWarn = `Si vous ne renseignez pas d'informations sur le validateur de ce document, les données de la carte CPx seront utilisées.\nSi vous renseignez un validateur manuellement, l'intégralité des champs doivent être complétés.`;

  constructor(
    private _formBuilder: FormBuilder,
    private _dmpSrv: DmpServiceAbstract,
    private _documentSrv: DocumentService,
    private _modalSrv: ModalService,
    private _viewContainerRef: ViewContainerRef,
    private _cpxHandleSrv: CpxHandleServiceAbstract,
    private _refSrv: ReferentielService,
    private _patientSrv: PatientService,
    private _logSrv: LogFonctionnelService
  ) { }

  async ngOnInit(): Promise<void> {
    this._logCallSrv = this._logSrv.getConfiguration(DomainEnum.Dmp);
    await this._initData();
    this._initForm();
  }

  ngOnDestroy(): void {
    if (this._subUpdateVisibilityAlone) {
      this._subUpdateVisibilityAlone.unsubscribe();
    }
    if (this._subUpdateVisibilityFromForm) {
      this._subUpdateVisibilityFromForm.unsubscribe();
    }
  }

  public closeModal(): void {
    this.closeEmitter.emit();
  }

  public changeDocumentFormat(formatType: DocumentFormatType): void {
    const otherFormatType: DocumentFormatType =
        formatType === DocumentFormatType.format ? DocumentFormatType.formatCode : DocumentFormatType.format;

    this.formGroup.get(formatType).setValidators(Validators.required);
    this.formGroup.get(formatType).updateValueAndValidity();
    this.formGroup.get(otherFormatType).clearValidators();
    this.formGroup.get(otherFormatType).updateValueAndValidity();
  }

  private _getVisibilitéChangeMessage(visibility: DmpVisibilityEnum): string | undefined {
    const isVisibleParPatient = (visib: DmpVisibilityEnum): boolean => {
      return visib === DmpVisibilityEnum['Le document est visible de tous']
      || visib === DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient']
      || visib === DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient et le professionnel de santé']
      || visib === DmpVisibilityEnum['Le document n\'est pas visible pour les professionnels de santé'];
    };

    const isVisibleParRL = (visib: DmpVisibilityEnum): boolean => {
      return visib === DmpVisibilityEnum['Le document est visible de tous']
      || visib === DmpVisibilityEnum['Le document n\'est pas visible pour le patient']
      || visib === DmpVisibilityEnum['Le document n\'est pas visible pour les professionnels de santé'];
    };

    let rtd: string | undefined = undefined;

    if (visibility !== this.document.visibility) {
      const newVisiblePatient = isVisibleParPatient(visibility);
      const newVisibleRepLeg = isVisibleParRL(visibility);
      if (newVisiblePatient && newVisibleRepLeg) {
        rtd = 'le patient et ses représentants légaux';
      } else if (newVisiblePatient && !newVisibleRepLeg && !isVisibleParPatient(this.document.visibility)) {
        rtd = 'le patient';
      } else if (!newVisiblePatient && newVisibleRepLeg && !isVisibleParRL(this.document.visibility)) {
        rtd = 'les représentants légaux du patient';
      }
    }

    return rtd;
  }

  public async onSubmit(): Promise<void> {
    const title = this.formGroup && this.formGroup.get('title') ? this.formGroup.get('title').value : undefined;
    const category = this.formGroup && this.formGroup.get('category') ? this.formGroup.get('category').value : undefined;
    const formatCode = this.formGroup && this.formGroup.get('formatCode') ? this.formGroup.get('formatCode').value : undefined;
    const format = this.formGroup && this.formGroup.get('format') ? this.formGroup.get('format').value : undefined;
    const visibility = this.formGroup && this.formGroup.get('visibility') ? this.formGroup.get('visibility').value : undefined;
    const commentaire = this.formGroup && this.formGroup.get('commentaire') ? this.formGroup.get('commentaire').value : undefined;
    const documentFormatType = this.formGroup && this.formGroup.get('documentFormatType')
        ? this.formGroup.get('documentFormatType').value : undefined;

    if (!title || title === '') {
      this._promptError('Le champ titre n\'est pas valide');
      return;
    }

    if (!category || category === '') {
      this._promptError('Le champ catégorie n\'est pas valide');
      return;
    }

    if ((documentFormatType as DocumentFormatType) === DocumentFormatType.formatCode && (!formatCode || formatCode === '')) {
      this._promptError('Le champ format code n\'est pas valide');
      return;
    }

    if ((documentFormatType as DocumentFormatType) === DocumentFormatType.format && (!format || format === '')) {
      this._promptError('Le champ format n\'est pas valide');
      return;
    }

    if (!visibility || visibility === '') {
      this._promptError('Le champ visibilité n\'est pas valide');
      return;
    }

    const displayAlertVisibility = this._getVisibilitéChangeMessage(visibility);

    const isPSInfosEmpty = (form: FormGroup): boolean => {
      return !!!(form.get('name').value
        || form.get('prenom').value
        || form.get('profession').value
        || form.get('speciality').value
        || form.get('idNat').value
        || form.get('idNatType').value
        // || form.get('practiceLocationBillingNumber').value
        // || form.get('practiceLocationName').value
        // || form.get('practiceSettingValue').value
        );
    };

    const isPSInfosOk = (form: FormGroup, personType: 'author' | 'performer' | 'authenticator'): true | false | string => {
      /**
       * TODO: Sujet à suivre
       * Les champs concernant la structure ne sont actuellement pas pris en compte par le connecteur DmpConnect.
       * Dans tout les cas celui-ci va utiliser les informations de strcuture présentent sur la carte CPx.
       * Ce sujet a été remonté à iCanopée et ils devraient ajouter cette possibilité prochainement.
       */

      console.log(form.get('profession').value);
      let personTypeLibelle;
      switch (personType) {
        case 'author':
          personTypeLibelle = 'l\'auteur';
          break;
        case 'authenticator':
          personTypeLibelle = 'le validateur';
          break;
        case 'performer':
          personTypeLibelle = 'l\'exécutant';
          break;
      }

      if (isPSInfosEmpty(form)) {
        return true;
      }

      if (form.get('profession').value) {
        const profession = (form.get('profession').value as string).split('++')[0];
        if (profession && ProfessionsAllowingSepcialities.includes(profession)) {
          if (
            !(
              !!(form.get('name').value
                || form.get('prenom').value
                || form.get('profession').value
                || form.get('speciality').value
                || form.get('idNat').value
                || form.get('idNatType').value
            // || form.get('practiceLocationBillingNumber').value
            // || form.get('practiceLocationName').value
            // || form.get('practiceSettingValue').value
              )
            && !(
              form.get('name').value
                && form.get('prenom').value
                && form.get('profession').value
                && form.get('speciality').value
                && form.get('idNat').value
                && form.get('idNatType').value
              // && form.get('practiceLocationBillingNumber').value
              // && form.get('practiceLocationName').value
              // && form.get('practiceSettingValue').value
            ))
          ) {
            return true
          } else {
            return false;
          }
        } else if (profession && !ProfessionsAllowingSepcialities.includes(profession)) {
          if (form.get('speciality').value) {
            return 'La spécialité n\'est pas autorisé pour cette profession';
          }

          if (
            !(
              !!(form.get('name').value
                || form.get('prenom').value
                || form.get('profession').value
                || form.get('idNat').value
                || form.get('idNatType').value
            // || form.get('practiceLocationBillingNumber').value
            // || form.get('practiceLocationName').value
            // || form.get('practiceSettingValue').value
              )
            && !(
              form.get('name').value
                && form.get('prenom').value
                && form.get('profession').value
                && form.get('idNat').value
                && form.get('idNatType').value
              // && form.get('practiceLocationBillingNumber').value
              // && form.get('practiceLocationName').value
              // && form.get('practiceSettingValue').value
            ))
          ) {
            return true
          } else {
            return false;
          }
        } else {
          return `La profession est manquantes pour ${personTypeLibelle}`;
        }
      } else {
        return `La profession est manquantes pour ${personTypeLibelle}`;
      }
    }

    const isPSInfosValid = (form: FormGroup): boolean => {
      /**
       * TODO: Sujet à suivre
       * Les champs concernant la structure ne sont actuellement pas pris en compte par le connecteur DmpConnect.
       * Dans tout les cas celui-ci va utiliser les informations de strcuture présentent sur la carte CPx.
       * Ce sujet a été remonté à iCanopée et ils devraient ajouter cette possibilité prochainement.
       */
      if (ProfessionsAllowingSepcialities.includes((form.get('profession').value as string))) {
        if (!!(form.get('name').value
          && form.get('prenom').value
          && form.get('profession').value
          && form.get('speciality').value
          && form.get('idNat').value
          && form.get('idNatType').value
          // && form.get('practiceLocationBillingNumber').value
          // && form.get('practiceLocationName').value
          // && form.get('practiceSettingValue').value
          )
        ) {
          return true
        } else {
          return false;
        }
      } else {
        if (!!(form.get('name').value
          && form.get('prenom').value
          && form.get('profession').value
          && form.get('idNat').value
          && form.get('idNatType').value
          // && form.get('practiceLocationBillingNumber').value
          // && form.get('practiceLocationName').value
          // && form.get('practiceSettingValue').value
          )
        ) {
          return true
        } else {
          return false;
        }
      }
    }
  
    const getInfosPs = (form: FormGroup): UserInfos | undefined => {
      if (isPSInfosValid(form)) {
        const profession = (form.get('profession').value as string).split('++');
        return {
          name: form.get('name').value,
          given: form.get('prenom').value,
          profession: profession[0],
          professionOid: profession[1],
          speciality: (form.get('speciality')?.value as string)?.split('++')[0],
          internalId: form.get('idNat').value,
          internalIdType: (form.get('idNatType').value as string).split('++')[0],
          institution: {
            practiceLocationBillingNumber: form?.get('practiceLocationBillingNumber')?.value,
            practiceLocationName: form?.get('practiceLocationName')?.value,
            practiceSettingValue: (form?.get('practiceSettingValue')?.value as string)?.split('++')[0],
          }
        };
      } else {
        return undefined;
      }
    }

    const isMasqueRl = (visibility: DmpVisibilityEnum): boolean => {
      return (visibility === DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient'] as any
      || visibility === DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"] as any
      || visibility === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"] as any)
    };

    const isAuthorFormOk = isPSInfosOk(this.authorForm, 'author');
    if (!isAuthorFormOk) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire incomplet', 'Les information sur l\'auteur ne sont pas complètes');
      return;
    } else if (typeof isAuthorFormOk === 'string') {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire non valide', isAuthorFormOk);
      return;
    }

    const isPerformerFormOk = isPSInfosOk(this.performerForm, 'performer');
    if (!isPerformerFormOk) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire incomplet', 'Les information sur l\'exécutant ne sont pas complètes');
      return;
    } else if (typeof isPerformerFormOk === 'string') {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire non valide', isPerformerFormOk);
      return;
    }

    const isAuthenticatoFormOk = isPSInfosOk(this.authenticatorForm, 'authenticator');
    if (!isAuthenticatoFormOk) {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire incomplet', 'Les information sur le validateur ne sont pas complètes');
      return;
    } else if (typeof isAuthenticatoFormOk === 'string') {
      this._modalSrv.openAlert(this._viewContainerRef, 'Formulaire non valide', isAuthenticatoFormOk);
      return;
    }

    if (this.document.uniqueId) {
      let loading: ComponentRef<LoadingModalFragment>;
      let confirm = false;
      let updateOk = false;

      try {
        loading = this._modalSrv.openLoading(this._viewContainerRef);
        this.isLoading = true;

        if ((!this._documentContent || this._documentContent === '') && !this.updateWithoutRight) {
          const content = await this._dmpSrv.hl_getdocumentcontent(this._viewContainerRef, {
            ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins,
            uniqueId: this.document.uniqueId,
            uuid: this.document.uuid,
          });
          if (content) {
            this._documentContent = content.s_fileContentInBase64;
          }
        }

        if (!this._documentContent && !this.updateWithoutRight) {
          return;
        } else if (!this._documentContent && this.updateWithoutRight) {
          this._modalSrv.openAlert(
            this._viewContainerRef,
            'Document manquant',
            'Vous devez renseigner un fichier pour modifier ce document DMP.'
          );
          return;
        }

        const doc: DmpHlsendDocumentsDocument = {
          EventCodes: this.document.eventCodes,
          i_format: (documentFormatType as DocumentFormatType) === DocumentFormatType.format ? format : undefined,
          i_visibility: DmpVisibilityEnum[visibility] as any,
          s_category: category,
          s_contentInBase64: this._documentContent,
          s_creationDate: undefined,
          s_description: commentaire,
          s_formatCode: (documentFormatType as DocumentFormatType) === DocumentFormatType.formatCode ? formatCode : undefined,
          s_serviceStartDate: undefined,
          s_serviceStopDate: undefined,
          s_title: title,
          s_uniqueId: this.document.uniqueId,
        };

        const isSameDoc = (): boolean => {
          return doc.s_title === this.document.title
            && doc.s_category === this.document.category
            && (
              doc.s_formatCode === this.document.formatCode
              || doc.i_format === this.document.format)
            && DmpVisibilityEnum[doc.i_visibility] as any === this.document.visibility
            && doc.s_description === this.document.description
            && doc.s_contentInBase64 === this.document.contentInBase64;
        };
        if (isSameDoc()) {
          this._modalSrv.openAlert(
            this._viewContainerRef, 'Aucun changement',
            'Aucune modification apportée à ce document, celui-ci ne sera pas envoyé sur le DMP du patient.'
          );
          return;
        }

        const session = await this._cpxHandleSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
        if (!session) {
          return;
        }

        let confirmMsg = 'Voulez-vous modifier ce document ?';
        if (displayAlertVisibility) {
          confirmMsg = `En sélectionnant cette visibilité, le document sera visible par ${displayAlertVisibility}.\n\nAttention : cette modification est irréversible.\n\n${confirmMsg}`;
        }

        if (!await this._confirmModal(confirmMsg)) {
          return;
        } else {
          confirm = true;
        }

        let confimSecretDelete = false;
        if (
          ((this.docFromDb as any)?.createdWithSecretmode || ((this.docFromDb as any)?.visibility && isMasqueRl((this.docFromDb as any).visibility)) || (isMasqueRl(this.document.visibility)))
          && !session.confidentialityLevel
        ) {
          const modalSecretConfirm = this._modalSrv.openModalConfirmation(
            this._viewContainerRef,
            'Connexion secrète',
            `Ce document a été ajouté en mode connexion secrète, la modification de ce document se fera également en connexion secrète.\n\nVoulez-vous continuer la modification ?`
          );
      
          confimSecretDelete = await new Promise<boolean>(resolve => {
            const sub = modalSecretConfirm.instance.closeEmitter.subscribe(async (res) => {
              resolve(res);
              sub.unsubscribe();
            });
          });
      
          if (!confimSecretDelete) {
            return;
          } else {
            await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, true);
          }
        }

        let patient = await this._patientSrv.findOnePatientFiche(this.patientId);
        if (!patient) {
          this._promptError('Impossible de récupérer les informations du patient pour l\'envoi de documents sur le DMP.');
          return;
        }

        const authenticator = getInfosPs(this.authenticatorForm);
        const author = getInfosPs(this.authorForm);
        await this._dmpSrv.hl_senddocument(this._viewContainerRef, {
            s_healthcareSetting: session.dmpConnectSessionInfos.PracticeLocations[session.practiceSettingIndice].s_practiceLocationHealthcareSettings,
            s_ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins,
            s_birthPlaceCode: patient.cpNaissance,
            Identity: this.patientInsIdentity,
            Author: author ? [ author ] : undefined,
            Performer: getInfosPs(this.performerForm),
            Authenticator: authenticator ? [ authenticator ] : undefined,
          },
          doc,
          undefined,
          this.patientId
        );

        updateOk = true;

        if (confimSecretDelete) {
          await this._dmpSrv.setConfidentialityLevel(this._viewContainerRef, false);
        }
      } catch (e) {
        this._promptError(e.message);
      } finally {
        if (loading) {
          loading.destroy();
        }
        this.isLoading = false;

        if (updateOk) {
          await new Promise<void>(resolve => {
            const docUpdateOkModal = this._modalSrv.openAlert(
              this._viewContainerRef,
              'Modification', `Le document ${title} a été modifié avec succès.`
            );
            const docUpdateOkModalSub = docUpdateOkModal.instance.closeEmitter.subscribe(() => {
              docUpdateOkModalSub.unsubscribe();
              resolve();
            });
          });
        }

        if (confirm) {
          this.closeModal();
        }
      }
    } else {
      const authenticator = getInfosPs(this.authenticatorForm);
      const author = getInfosPs(this.authorForm);
      const performer = getInfosPs(this.performerForm);
      this.closeEmitter.emit({ docFormData: {
        category,
        formatCode: (documentFormatType as DocumentFormatType) === DocumentFormatType.formatCode ? formatCode : undefined,
        contentInBase64: '',
        description: commentaire,
        eventCodes: undefined,
        format: (documentFormatType as DocumentFormatType) === DocumentFormatType.format ? format : undefined,
        title,
        visibility,
        status: this.document.status,
        author: author ? [ author ] : undefined,
        performer: performer,
        authenticator: authenticator ? [ authenticator ] : undefined,
      }, valideMessage: null});
    }
  }

  private async _confirmModal(message: string): Promise<boolean> {
    return new Promise<boolean>(async (resolve, reject) => {
      const modal = this._modalSrv.openModalConfirmation(
        this._viewContainerRef,
        'Confirmation',
        message
      );
      const sub = modal.instance.closeEmitter.subscribe(res => {
        sub.unsubscribe();
        modal.destroy();
        resolve(!!res);
      });
    });
  }

  public async onSubmitVisibility(): Promise<void> {
    try {
      const visibility = this.formGroupVisibility.get('visibility')?.value as  number;
      if (visibility && visibility !== this.document.visibility) {
        const session = await this._cpxHandleSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
        if (!session) {
          return;
        }

        let msg = 'Voulez-vous modifier la visibilité de ce document ?';
        const displayAlertVisibility = this._getVisibilitéChangeMessage(visibility);
        if (visibility === DmpVisibilityEnum['Le document est visible de tous']) {
          msg = `En sélectionnant cette visibilité, le document sera visible par ${displayAlertVisibility}.\n\nAttention : cette modification est irréversible.\n\n${msg}`;
        }

        if (!await this._confirmModal(msg)) {
          return;
        }

        this.formGroup.get('visibility').setValue(visibility, { emitEvent: false });
        const res = await this._dmpSrv.updateVisibilityDocumentByUniqueId(this._viewContainerRef, {
          s_ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins,
          s_documentUniqueId: this.document.uniqueId,
          s_documentUuid: this.document.uuid,
          s_healthCareSettings: session.dmpConnectSessionInfos.PracticeLocations[session.practiceSettingIndice].s_practiceLocationActivity,
          i_document_Visibility: visibility
        });

        // UpdateDocumentSet ne retourne pas le nouvel UUID, il faut donc le récupérer après la mise à jour pour mettre à jour notre base locale
        if (res && res.s_status !== 'ERROR' && this.docFromDb) {
          const currentUuid = await this._dmpSrv.hl_getDocumentUuidByUniqueId(this._viewContainerRef, {
            s_documentUniqueId: this.document.uniqueId,
            s_ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins
          });

          if (currentUuid) {
            const obj: any = {
              uuid: currentUuid,
              uniqueId: this.document.uniqueId,
              patientIns: this.dmpStatus.ExistingTestAnswer.AdminData.Ins.s_ins,
              rpps: session.dmpConnectSessionInfos.s_internalId,
              title: this.document.title,
              category: (this.document as any).category,
              visibility: visibility,
              createdWithSecretmode: !!session.confidentialityLevel,
            };
            if ((this.document as any).format) obj.format = (this.document as any).format;
            if ((this.document as any).formatCode) obj.formatCode = (this.document as any).formatCode;
            if (this.document.description) obj.comment = this.document.description;

            await this._dmpSrv.addMyDocuments(obj, this.document.uniqueId);
          }
        }
        
        const visibiliteString = DmpVisibilityEnum[visibility] as string;
        await this._logCallSrv.addLog({
          action: ActionEnum.Update,
          result: ResultEnum.Success,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: this.patientId,
          subDomain: 'Visibilité document DMP',
          internals: { documentUniqueId: this.document.uniqueId, visibility: visibiliteString },
          details: `Modification de la visibilité du document ${this.document.title} : ${visibiliteString}`
        });
      }

      const headerLibelle = `Visibilité modifiée`;
      const messageLibelle = `La visibilité du document ${this.document.title} a été modifiée avec succès.`;
      this.closeEmitter.emit({ docFormData: undefined, valideMessage: { header: headerLibelle, message: messageLibelle } });
    } catch (e) {
      if (this._logCallSrv) {
        this._logCallSrv.addLog({
          action: ActionEnum.Update,
          result: ResultEnum.Error,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: this.patientId,
          subDomain: 'Visibilité document DMP',
          internals: { documentUniqueId: this.document.uniqueId, error: e.message },
          details: `Echec de la modification de la visibilité du document ${this.document.title}`
        });
      }
      this._promptError(e.message);
    }
  }

  public async onSubmitArchive(): Promise<void> {
    try {
      const session = await this._cpxHandleSrv.getCpxSession(this._viewContainerRef, SessionTypeEnum.CARTE);
      if (!session) {
        return;
      }

      let confirmMsg = '';
      if (this.document.status === DmpStatusEnum.Courant) {
        confirmMsg = 'Voulez-vous archiver ce document ?';
      } else {
        confirmMsg = 'Voulez-vous désarchiver ce document ?';
      }
      if (!await this._confirmModal(confirmMsg)) {
        return;
      }

      await this._dmpSrv.archiveDocumentByUniqueId(this._viewContainerRef, {
        s_ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins,
        s_documentUniqueId: this.document.uniqueId,
        s_healthcareSettings: session.dmpConnectSessionInfos.PracticeLocations[session.practiceSettingIndice].s_practiceLocationActivity,
        s_documentUuid: this.document.uuid || undefined
      });

      let headerLibelle: string;
      let messageLibelle: string;
      let actionName = 'Archivage';
      if (this.document.status === DmpStatusEnum.Courant) {
        headerLibelle = 'Archivage validé';
        messageLibelle = `Le document ${this.document.title} a bien été archivé.`;
        actionName = 'Archivage';
      } else if (this.document.status === DmpStatusEnum['Document archivé']) {
        headerLibelle = 'Désarchivage validé';
        messageLibelle = `Le document ${this.document.title} a bien été désarchivé.`;
        actionName = 'Désarchivage';
      }

      if (this._logCallSrv) {
        await this._logCallSrv.addLog({
          action: ActionEnum.Update,
          result: ResultEnum.Success,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: this.patientId,
          subDomain: 'Statut document DMP',
          internals: { documentUniqueId: this.document.uniqueId, status: this.document.status },
          details: `${actionName} du document ${this.document.title}`
        });
      }

      this.closeEmitter.emit({ docFormData: undefined, valideMessage: headerLibelle && messageLibelle ? { header: headerLibelle, message: messageLibelle } : undefined });
    } catch (e) {
      if (this._logCallSrv && this.document) {
        let actionName = this.document.status === DmpStatusEnum.Courant ? 'Archivage' : 'Désarchivage';
        this._logCallSrv.addLog({
          action: ActionEnum.Update,
          result: ResultEnum.Error,
          typeTarget: TypeTargetEnum.Patient,
          idTarget: this.patientId,
          subDomain: 'Statut document DMP',
          internals: { documentUniqueId: this.document.uniqueId, status: this.document.status, error: e.message },
          details: `Echec de l'${actionName.toLowerCase()} du document ${this.document.title}`
        });
      }
      this._promptError(e.message);
    }
  }

  public importDocument(): void {
    const body = document.getElementsByTagName('body')[0];
    const inputElem = document.createElement('input');
    inputElem.type = 'file';
    inputElem.setAttribute('multiple', 'false');
    body.appendChild(inputElem);
    inputElem.click();
    inputElem.addEventListener('change', async (event: any) => {
      const titleField = this.formGroup.get('title');
      if (titleField) {
        titleField.setValue((event.target.files[0] as File).name);
      }
      this._documentContent = await this._documentSrv.convertFileToBase64(event.target.files[0]);
    });
  }

  private async _isPatientMineur(): Promise<boolean> {
    const dmpParams = await this._dmpSrv.getDmpParameters(this._viewContainerRef);
    if (this.patientInsIdentity && this.patientInsIdentity.s_birthDate && dmpParams.minorFunctionManagement) {
      if (dmpParams.majorityAge && moment(new Date()).subtract(dmpParams.majorityAge, 'year').isBefore(moment(this.patientInsIdentity.s_birthDate, 'YYYY-MM-DD'))) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  private async _initForm(): Promise<void> {
    const interopCodes = await this._dmpSrv.hl_getInteropCodes(
      this._viewContainerRef,
      [
        DmpHlGetInteropCodesEnum.docTypes,
        DmpHlGetInteropCodesEnum.docFormats
      ]);

    if (interopCodes && interopCodes[DmpHlGetInteropCodesEnum.docTypes]) {
      for (const docType of interopCodes[DmpHlGetInteropCodesEnum.docTypes]) {
        if (docType.i_validAlimentation && docType.i_validForSending ) {
          this.dmpParamCategory.push({
            id: docType.s_code,
            libelle: docType.s_displayName,
            meta: docType
          });
        }

        this.dmpParamCategory = this._sortNgSelectValue(this.dmpParamCategory);
      }
    }

    if (interopCodes && interopCodes[DmpHlGetInteropCodesEnum.docFormats]) {
      for (const docFormat of interopCodes[DmpHlGetInteropCodesEnum.docFormats]) {
        this.dmpParamFormatCode.push({
          id: docFormat.s_code,
          libelle: docFormat.s_displayName,
          meta: docFormat
        });

        this.dmpParamFormatCode = this._sortNgSelectValue(this.dmpParamFormatCode);
      }
    }

    Object.keys(DmpFormatEnum).filter((f) => {
      if (isNaN(Number(f))) {
        this.dmpParamFormat.push({
          id: DmpFormatEnum[f],
          libelle: f
        });
      }
    });
    this.dmpParamFormat = this._sortNgSelectValue(this.dmpParamFormat);

    const confidentialityLevel = await this._dmpSrv.getConfidentialityLevel(this._viewContainerRef);
    const isPatientMineur = await this._isPatientMineur();
    Object.keys(DmpVisibilityEnum).filter(async (v) => {
      if (isNaN(Number(v))) {
        const visibility: NgSelectValue = {
          id: DmpVisibilityEnum[v],
          libelle: v
        };
        if (confidentialityLevel && (
          visibility.id === DmpVisibilityEnum["Le document est visible de tous"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible pour le patient"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible pour les professionnels de santé"] as any
        )) {
          visibility.disabled = true;
        }

        if (this.document && (
          this.document.visibility === DmpVisibilityEnum["Le document est visible de tous"]
          || this.document.visibility === DmpVisibilityEnum["Le document n'est pas visible pour les professionnels de santé"]
          || this.document.visibility === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient"]
          || this.document.visibility === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"]
          ) && (
          visibility.id === DmpVisibilityEnum["Le document n'est pas visible pour le patient"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"] as any
          )
        ) {
          visibility.disabled = true;
        }

        if (this.document && (
          this.document.visibility === DmpVisibilityEnum["Le document est visible de tous"]
          || this.document.visibility === DmpVisibilityEnum["Le document n'est pas visible pour le patient"]
          || this.document.visibility === DmpVisibilityEnum["Le document n'est pas visible pour les professionnels de santé"]
          ) && (
          visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"] as any
          )
        ) {
          visibility.disabled = true;
        }

        if (!isPatientMineur
          && (visibility.id === DmpVisibilityEnum['Le document n\'est pas visible par le représentant légal du patient'] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le patient et le représentant légal"] as any
          || visibility.id === DmpVisibilityEnum["Le document n'est pas visible par le représentant légal du patient et le professionnel de santé"] as any)) {
          visibility.disabled = true;
        }

        this.dmpParamVisibility.push(visibility);
      }
    });

    const documentFormatType = this.document.format || (!this.document.format && !this.document.formatCode)
      ? DocumentFormatType.format : DocumentFormatType.formatCode;
    this.formGroup = this._formBuilder.group({
      title: [this.document.title, [Validators.required, Validators.maxLength(128)]],
      category: [this.document.category, Validators.required],
      formatCode: [this.document.formatCode], // TODO Trouver cette valeur dans le document
      format: [this.document.format, Validators.required],
      visibility: [this.document.visibility, Validators.required],
      commentaire: [this.document.description],
      documentFormatType: [documentFormatType],
    });
    this._subUpdateVisibilityFromForm = this.formGroup.get('visibility').valueChanges.subscribe(v => {
      this.formGroupVisibility.get('visibility').setValue(v, { emitEvent: false })
    });

    this.formGroupVisibility = this._formBuilder.group({
      visibility: [this.document.visibility, Validators.required],
    });
    // this._subUpdateVisibilityAlone = this.formGroupVisibility.get('visibility').valueChanges.subscribe(v => {
    //   this.formGroup.get('visibility').setValue(v, { emitEvent: false })
    // });
    if (this.docFromDb) {
      this.changeDocumentFormat(documentFormatType);
    }

    this.formGroupArchive = this._formBuilder.group({
      archived: [DmpStatusEnum[this.document.status], Validators.required],
    });

    this.authorForm = this._formBuilder.group({
      name: [''],
      prenom: [''],
      profession: [''],
      speciality: [''],
      idNat: [''],
      idNatType: [''],
      practiceLocationBillingNumber: [''],
      practiceLocationName: [''],
      practiceSettingValue: [''],
    });

    this.performerForm = this._formBuilder.group({
      name: [''],
      prenom: [''],
      profession: [''],
      speciality: [''],
      idNat: [''],
      idNatType: [''],
      practiceLocationBillingNumber: [''],
      practiceLocationName: [''],
      practiceSettingValue: [''],
    });

    this.authenticatorForm = this._formBuilder.group({
      name: [''],
      prenom: [''],
      profession: [''],
      speciality: [''],
      idNat: [''],
      idNatType: [''],
      practiceLocationBillingNumber: [''],
      practiceLocationName: [''],
      practiceSettingValue: [''],
    });
  }

  private async _initData(): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {
      const loading = this._modalSrv.openLoading(this._viewContainerRef);
      try {
        const practiceSettingsArrTmp = await this._refSrv.findRefListTableHypermed('RefPracticeSettingCodeDMP');
        for (const ps of practiceSettingsArrTmp) {
          this.dmpPracticeSettings.push({
            id: ps.id,
            libelle: ps.libelle
          });
        }

        let subjectRoleSettingsArrTmp = await this._refSrv.findRefListTableHypermed('RefSubjectRoleDMP');

        const specialiteSettingsTmp: Array<NgSelectValueSrv> = [];
        for (const ps of subjectRoleSettingsArrTmp) {
          /**
           * On alimente la liste des spécialités
           * seulement avec les rôles ayant un code
           * qui N'EST PAS un Number
           */
          const psId = ps.id.split('++')[0];
          if (isNaN(Number(psId))) {
            specialiteSettingsTmp.push({
              id: ps.id,
              libelle: ps.libelle
            });
          }
        }
        this.specialiteSettings = this._sortNgSelectValue(specialiteSettingsTmp);

        const professionSettingsTmp: Array<NgSelectValueSrv> = [];
        for (const ps of subjectRoleSettingsArrTmp) {
          /**
           * On alimente la liste des professions
           * seulement avec les rôles ayant un code
           * qui EST un Number
           */
          const psId = ps.id.split('++')[0];
          if (!isNaN(Number(psId))) {
            professionSettingsTmp.push({
              id: ps.id,
              libelle: ps.libelle
            });
          }
        }
        this.professionSettings = this._sortNgSelectValue(professionSettingsTmp);


        if (this.document.uniqueId && this.document.uuid && !this.docFromDb) {
          const content = await this._dmpSrv.hl_getdocumentcontent(this._viewContainerRef, {
            ins: this.dmpStatus.ExistingTestAnswer.AdminData.Ins,
            uniqueId: this.document.uniqueId,
            uuid: this.document.uuid,
          });
          if (content?.s_fileContentInBase64) {
            this.document.contentInBase64 = content.s_fileContentInBase64;
          }
        }

        resolve();
      } catch (e) {
        reject(e);
      } finally {
        loading.destroy();
      }
    });
  }

  private _promptError(msg: string): void {
    let contextMsg = 'Une erreur est survenue';

    const msgSplit = msg.split('\n');
    if (msgSplit.length > 1) {
      const obj = {};
      for (const str of msgSplit) {
        const strSplit = str.split(/ : (.*)/s);
        obj[strSplit[0]] = Number.isNaN(Number(strSplit[1])) ? strSplit[1] : Number(strSplit[1]);
      }
      if (typeof obj === 'object') {
        if ((obj as any).s_apiErrorTypeDescription === 'DMPError') {
          contextMsg = `${(obj as any).s_apiErrorDescription}`;
          contextMsg += `\n${(obj as any).s_apiErrorDmpErrorDetails}`;

          msg = `Code d'erreur : ${(obj as any).s_apiErrorDmpErrorCode}`;
          msg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
          msg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
          msg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorExtendedInformations}`;
        } else if ((obj as any).s_apiErrorTypeDescription === 'ApiError') {
          contextMsg = `Code d'erreur : ${(obj as any).i_apiErrorCode}`;
          contextMsg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
          contextMsg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
          contextMsg += `\nDescription de l'erreur : ${(obj as any).s_apiErrorDescription}`;
          contextMsg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorExtendedInformations}`;
          msg = undefined;
        } else if ((obj as any).s_status && ((obj as any).s_status === 'ERROR' || (obj as any).s_status === 'API_ERROR')) {
          contextMsg = (obj as any).s_apiErrorDescription ? (obj as any).s_apiErrorDescription : contextMsg;
          if ((obj as any).s_apiErrorDmpErrorCode && (obj as any).s_apiErrorTypeDescription && (obj as any).s_apiErrorDmpErrorDetails) {
            msg = `Code d'erreur : ${(obj as any).s_apiErrorDmpErrorCode}`;
            msg += `\nType de l'erreur : ${(obj as any).s_apiErrorTypeDescription}`;
            msg += `\nContexte de l'erreur : ${(obj as any).s_apiErrorContext}`;
            msg += `\nDétails de l'erreur : ${(obj as any).s_apiErrorDmpErrorDetails}`;
          } else {
            msg = (obj as any).s_apiErrorDmpErrorDetails ? (obj as any).s_apiErrorDmpErrorDetails : msg;
          }
        }

        if ((obj as any).s_requestFrameInBase64) {
          console.error('Message d\'erreur pour le support (request) : ', (obj as any).s_requestFrameInBase64);
        }
        if ((obj as any).s_answerFrameInBase64) {
          console.error('Message d\'erreur pour le support (response) : ', (obj as any).s_answerFrameInBase64);
        }
      }
    }

    this._modalSrv.openAlert(
      this._viewContainerRef,
      'Erreur',
      contextMsg,
      undefined,
      msg
    );
  }

  private _sortNgSelectValue(arr: Array<NgSelectValue>): Array<NgSelectValue> {
    return arr.sort((a, b) => {
      if (a.libelle > b.libelle) {
        return 1;
      }
      if (b.libelle > a.libelle) {
        return -1;
      }
      return 0;
    });
  }

  public selectTab(tab: TabInfos): void {
    this.currentTab = tab;
  }

}
